module.exports = __webpack_public_path__ + "img/logob.01ff1918.png";